// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__bJt95","content":"page_content__TWUkN"};